<template>
  <div>
    <div class="layout layout--horizontal layout--align-start">
      <p class="grow half-spacing">
        <template v-if="isPending">
          Pending With
        </template>

        <template v-else>
          Paid With
        </template>
      </p>

      <div class="right">
        <div
          v-for="p in payment.payments"
          :key="p.id"
          class="no-wrap spacing dark"
        >
          <template v-if="p.paymentType === 'Offer'">
            {{ discountNames }}
          </template>

          <template v-else-if="p.paymentType === 'RoomCharge'">
            Charged to Room
          </template>

          <template v-else-if="p.paymentType === 'InStore'">
            <div class="flex align-center justify-end half-gap">
              In Store

              <span class="dark-gray">
                {{ getPaymentAmountDisplay(p) }}
              </span>
            </div>
          </template>

          <template v-else>
            <div class="flex align-center justify-end half-gap">
              <card-type-icon
                :card-type="p.cardType"
                :payment-type="p.paymentType"
              />

              <template v-if="p.cardNumberLastFour">
                <span>••••</span>
                <span>{{ p.cardNumberLastFour }}</span>
              </template>

              <span
                v-if="payment.payments.length > 1"
                class="dark-gray"
              >
                {{ getPaymentAmountDisplay(p) }}
              </span>
            </div>

            <div
              v-if="p.paymentType === 'GiftCard' && (p.giftCardRemainingBalance || p.giftCardRemainingBalance === 0)"
              class="smaller dark-gray quarter-spacing-top"
            >
              Remaining Balance: {{ $dollars(p.giftCardRemainingBalance) }}
            </div>
          </template>
        </div>
      </div>
    </div>

    <div
      v-if="payment.transactionDateTime"
      class="layout layout--horizontal"
    >
      <p class="grow">
        Payment Date
      </p>

      <p class="no-wrap dark">
        {{ $formatDateTime(payment.transactionDateTime, order.store?.timeZone) }}
      </p>
    </div>

    <div
      v-if="displayStoreLocation"
      class="layout layout--horizontal layout--align-start"
    >
      <p class="grow">
        Location
      </p>

      <div class="flex-column align-end">
        <p class="dark bold no-spacing">
          {{ order.store.description }}
        </p>

        <p
          v-for="(line, i) in storeAddressLines"
          :key="`store-${i}`"
          class="smaller no-spacing"
        >
          {{ line }}
        </p>
      </div>

    </div>
  </div>
</template>


<script>
  import dollars from '@/filters/dollars';

  import { formatAddress } from '@/helpers/address-format';


  export default {
    name: 'YourPayment',

    props: {
      isPending: {
        type: Boolean,
        default: false
      },

      order: {
        type: Object,
        default() {
          return {
            offers: []
          };
        }
      },

      payment: {
        type: Object,
        required: true
      },

      displayStoreLocation: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      storeAddressLines() {
        const addr = this.order?.store?.address;
        if (!addr) return [];
        return formatAddress(addr, addr.countryCode);
      },

      discountNames() {
        const names = [];

        this.order.offers.forEach((offer) => {
          const name = offer.name || offer.promotionCode;

          if (name) {
            names.push(name);
          }
        });

        return names.join(', ');
      }
    },

    methods: {
      getPaymentAmountDisplay(payment) {
        let totalString = `(${dollars(payment.amount)}`;

        if (payment.surcharge) totalString += ` + ${dollars(payment.surcharge)}`;

        totalString += ')';

        return totalString;
      }
    }
  };
</script>
